<template>
  <div class="text-center mt-4 qr-box-wrapper" light>
    <v-card-actions class="pa-0">
      <ScissorsIcon class="cut-icon"></ScissorsIcon>
      <v-spacer></v-spacer>
      <v-btn @click="closeWindow()" icon small elevation="0">
        <XCircleIcon class="hero-icon-button"></XCircleIcon>
      </v-btn>
    </v-card-actions>
    <v-sheet class="pa-4 qr-box" outlined>
      <div class="text-uppercase text-h4">
        <div v-if="specialPoster == 'product'" class="pa-4">
          {{ $t("message.purchase_item") }}
        </div>
        <div v-else-if="specialPoster == 'waiver'" class="text-center">
          {{ $t("message.sign_our_waiver") }}
        </div>
        <div v-else-if="specialPoster == 'invite'">
          {{ $t("message.register_with_academy") }}
        </div>
        <div v-else-if="specialPoster == 'contact'">
          {{ $t("message.contact_us") }}
        </div>
        <div v-else-if="specialPoster == 'new_visit'">
          {{ $t("message.schedule_your_visit") }}
        </div>
        <div v-else-if="specialPoster == 'memberships'">
          {{ $t("message.memberships") }}
        </div>
        <div v-else-if="specialPoster == 'schedule'">
          {{ $t("message.academy_schedule") }}
        </div>
      </div>
      <v-row>
        <v-col></v-col>
        <v-col>
          <v-divider></v-divider>
        </v-col>
        <v-col></v-col>
      </v-row>
      <div class="text-uppercase text-h6 mt-3" style="width:60%;margin-left:auto;margin-right:auto">
        <div v-if="specialPoster == 'waiver'" v-html="$t('message.scan_to_sign')"></div>
        <div v-else-if="specialPoster == 'invite'" v-html="$t('message.scan_to_register')"></div>
        <div v-else-if="specialPoster == 'product' && product">
          <v-avatar size="200" class="pb-2" v-if="product.image">
            <img :src="userImg(product.image)" />
          </v-avatar>
          <v-card-text class="text-h6 text-uppercase">
            {{ product.name }}
          </v-card-text>
          <v-card-text class="pa-0 text-h2 text-uppercase text-truncate">
            {{ product.amountDecimal }} {{ product.currency }}
          </v-card-text>
        </div>
        <div v-else-if="specialPoster == 'event' && title" v-html="title"></div>
        <div v-else-if="specialPoster == 'document' && title" v-html="title"></div>
      </div>
      <div class="pa-0">
        <div style="display: inline-block;padding: 5px; border: 2px solid darkslategrey; border-radius: 5px;">
          <vue-qr v-if="url" :text="url" :size="300"></vue-qr>
        </div>
      </div>
      <div style="height: 40px; overflow-y:hidden;padding:0px;">
        <img style="vertical-align:middle;height: 90px;margin-top:-30px"
          :src="assets('logo-simple-outlined-black-small.png')" />
      </div>
      <div class="text-uppercase text-h6">
        {{ $t("message.scan_to_complete") }}
      </div>
    </v-sheet>
    <v-card-actions v-if="url" class="text-center text-subtitle-2">
      <v-spacer></v-spacer>
      <v-btn outlined @click="copyUrl()" color="primary">{{ $t("message.copy_url") }}</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </div>
</template>

<script>
import Api from '@/services/Api';
import VueQr from 'vue-qrcode-component';

//<vue-qr v-if="url" :logoSrc="'/logo-circle-gray.png'" :text="url" :size="300"></vue-qr>
import {
  ScissorsIcon,
  XCircleIcon,
} from '@vue-hero-icons/outline';

export default {
  data() {
    return {
      encodedUrl: this.$route.params.url,
      encodedUrlQuery: this.$route.query.url,
      productId: this.$route.query.p,
      specialPoster: this.$route.query.sp,
      title: this.$route.query.t,
      url: null,
      product: null,
      logo: this.assets('logo-circle-gray.png')
    };
  },
  components: {
    VueQr,
    ScissorsIcon,
    XCircleIcon
  },
  created() {
    if (this.specialPoster == 'invite') {
      if (this.encodedUrl)
        this.url = atob(decodeURIComponent(this.encodedUrl));
      else if (this.encodedUrlQuery)
        this.url = atob(this.encodedUrlQuery);
    } else {
      if (this.encodedUrl)
        this.url = atob(this.encodedUrl);
      else if (this.encodedUrlQuery)
        this.url = atob(this.encodedUrlQuery);
    }
    if (this.productId) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/products/" +
          this.productId
        )
        .then((response) => {
          this.product = response.data;
        })
        .catch((e) => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    }
  },
  watch: {
  },
  methods: {
    closeWindow() {
      if (window.history.length > 1) {
        this.goBack();
        return;
      }
      window.close();
    },
    copyUrl() {
      this.copyToClipboard(this.url);
    },
  }
};
</script>

<style scoped>
.qr-box {
  margin-left: auto;
  margin-right: auto;
  border: 2px dashed lightgray;
  max-width: 480px;
}

.qr-box-wrapper {
  width: 480px;
  margin-left: auto;
  margin-right: auto;
}

.cut-icon {
  right: 0;
  text-align: left;
}
</style>